export default "__VITE_ASSET__BBVDA0I6__"